var deepmerge = require('lib/deepmerge');
var isFunction = require('lib/util').isFunction;

// https://github.com/just-boris/require-mini

function safeGet(global, value) {
    return value.split('.').reduce(function (obj, prop) {
        return obj && obj[prop];
    }, global);
}

function defer() {
    var result = {};
    result.promise = new Promise(function (resolve, reject) {
        result.resolve = resolve;
        result.reject = reject;
    });
    return result;
}

function invokeLater(context, fn) {
    lastTask = lastTask.then(function () {
        pendingModule = context;
        return fn();
    }).then(cleanup, cleanup);

    function cleanup() {
        pendingModule = null;
    }
}

function appendJs(name) {
    return /^\/|:|\?|\.js$/.test(name) ? name : name + '.js';
}

function pathName(name, path) {
    var pathname = name,
        re = /^\.+\//,
        a = path.slice(0, path.length - 1),
        component;
    while (a.length && re.test(pathname)) {
        component = a.pop();
        component = component.substr(component.lastIndexOf('!') + 1);
        pathname = component.substr(0, component.lastIndexOf('/') + 1).replace(/^!+/, '') + pathname;
    }
    return pathname;
}

var contexts = {},
    lastTask = Promise.resolve(),
    pendingModule = null;

function createContext(contextName, contextOptions) {

    contextOptions = contextOptions || {};

    if (!contexts[contextName]) {

        function loadDep(name, path) {
            if (config.shim[name]) {
                return loadByShim(name, path);
            } else {
                var deferred = defer();
                deferred.name = name;
                deferred.path = path;
                deferred.context = contextName;
                invokeLater(deferred, function () {
                    return loadScript(name, path).catch(function () {
                        deferred.reject(new Error('Error while loading module "' + name + '"'));
                    });
                });
                return deferred.promise;
            }
        }

        function loadByShim(name, path) {
            var shim = config.shim[name];
            return _require(shim.deps || [], function () {
                return loadScript(name, path).then(shim.exportsFn || function () {
                    return (shim.init && shim.init()) || safeGet(window, shim.exports);
                });
            }, null, path);
        }

        function loadScript(name, path) {
            return new Promise(function (resolve, reject) {
                var el = requirejs.load(null, name, toUrl(name, path, true));
                el.onerror = reject;
                el.onload = resolve;
            });
        }

        function loadWithPlugin(dependency, path) {
            var index = dependency.lastIndexOf('!'),
                plugin = dependency.substr(0, index).replace(/^!+/, ''),
                context = createContext(null).getContext();
            dependency = dependency.substr(index + 1);
            return context._require([plugin], function (plugin) {
                return new Promise(function (resolve, reject) {
                    function localRequire() {
                        if (!resolved) {
                            return requirejs.apply(null, arguments);
                        }
                    }
                    Object.keys(requirejs).forEach(function (key) {
                        localRequire[key] = requirejs[key];
                    });
                    var resolved = false;
                    resolve.error = reject;
                    resolve.fromText = function (name, text) {
                        if (!text) {
                            text = name;
                        }
                        var previousModule = pendingModule;
                        pendingModule = {
                            name: name,
                            resolve: resolve,
                            reject: reject,
                            path: path
                        };
                        /* jshint -W054 */
                        (new Function(text))();
                        /* jshint +W054 */
                        pendingModule = previousModule;
                        resolved = true;
                    };
                    plugin.load(pathName(dependency, path), localRequire, resolve, config);
                });
            }, null, path);
        }

        var commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,
            cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]*)["']\s*\)/g;

        function wrapCommonJS(name, factory, path) {
            var deps = [];
            factory.toString()
                .replace(commentRegExp, '')
                .replace(cjsRequireRegExp, function (match, dep) {
                    deps.push(dep);
                });

            return {
                deps: deps,
                factory: function () {
                    var args = arguments,
                        modules = deps.reduce(function (modules, name, index) {
                            modules[name] = args[index];
                            return modules;
                        }, {});

                    function localRequire(name) {
                        if (!modules[name]) {
                            throw new Error('Module "' + deps + '" has not been loaded yet');
                        }
                        return modules[name];
                    }

                    localRequire.toUrl = function (name) {
                        return toUrl(name, path);
                    };

                    return factory(
                        localRequire,
                        locals.exports(name),
                        locals.module(name)
                    );
                }
            };
        }


        function _require(deps, factory, errback, path) {
            var currentModule = path.slice(-1)[0];
            return new Promise(function (resolve, reject) {
                Promise.all(deps.map(function (dependency) {
                    if (path.indexOf(dependency) > -1) {
                        return Promise.reject(new Error('Circular dependency: ' + path.concat(dependency).join(' -> ')));
                    }
                    var newPath = path.concat(dependency);
                    if (locals[dependency]) {
                        return locals[dependency](currentModule);
                    }
                    if (dependency.indexOf('!') > -1) {
                        modules[dependency] = loadWithPlugin(dependency, newPath);
                    }
                    if (predefines[dependency]) {
                        modules[dependency] = Promise.resolve().then(function () {
                            return _require.apply(null, predefines[dependency].concat([newPath]));
                        });
                    } else if (!modules[dependency]) {
                        modules[dependency] = loadDep(dependency, newPath);
                    }
                    return modules[dependency];
                })).then(resolve, reject);
            }).then(function (instances) {
                if (isFunction(factory)) {
                    var result = factory.apply(null, instances);
                    return currentModule && safeGet(modules[currentModule], 'module.exports') || result;
                } else {
                    return factory;
                }
            }, function (reason) {
                if (isFunction(errback)) {
                    errback(reason);
                }
                requirejs.onError(reason);
                return Promise.reject(reason);
            });
        }

        function requirejs(deps, factory, errback) {
            return _require(deps, factory, errback, []);
        }

        var modules,
            predefines,
            config,
            locals = {
                require: function (moduleName) {
                    return requirejs;
                },
                module: function (moduleName) {
                    var module = modules[moduleName];
                    if (!module) {
                        throw new Error('Module "module" should be required only by modules');
                    }
                    return (module.module = module.module || {
                        id: moduleName,
                        config: function () {
                            return config.config[moduleName] || {};
                        }
                    });
                },
                exports: function (moduleName) {
                    return (locals.module(moduleName).exports = {});
                }
            };

        requirejs.resetContext = function () {
            config = {
                urlArgs: '',
                baseUrl: './',
                paths: {},
                shim: {},
                bundles: {},
                config: {}
            };
            modules = {};
            predefines = {};
        };

        requirejs.config = function (options) {
            if (!options.context) {
                config = deepmerge(config, options);
            } else {
                return createContext(options.context, options);
            }
        };

        requirejs.load = function (context, name, url) {
            var el = document.createElement("script");
            el.src = url;
            el.async = true;
            document.getElementsByTagName('body')[0].appendChild(el);
            return el;
        };

        function toUrl(name, path, appendJS) {
            var bundle = Object.keys(config.bundles).filter(function (bundle) {
                return config.bundles[bundle].indexOf(name) > -1;
            })[0];
            if (bundle) {
                return requirejs.toUrl(bundle);
            }
            if (config.paths[name]) {
                name = config.paths[name];
                if (appendJS) {
                    name += '.js';
                }
            } else {
                if (appendJS) {
                    name = appendJs(name);
                }
                if (path) {
                    name = pathName(name, path);
                }
            }
            if (!/^([\w\+\.\-]+:)?\//.test(name)) {
                name = config.baseUrl + name;
            }
            if (config.urlArgs) {
                name += '?' + config.urlArgs;
            }
            return name;
        }

        requirejs.toUrl = function (name) {
            return toUrl(name);
        };

        requirejs.specified = function (name) {
            return modules.hasOwnProperty(name);
        };

        requirejs.onError = function (reason) {
            console.error(reason);
        };

        requirejs.resetContext();

        requirejs.getContext = function () {
            return {
                config: config,
                modules: modules,
                predefines: predefines,
                wrapCommonJS: wrapCommonJS,
                _require: _require
            };

        };

        contexts[contextName] = requirejs;
    }

    var options = deepmerge({}, contextOptions);
    delete options.context;
    contexts[contextName].config(options);

    return contexts[contextName];
}

function define(name, deps, factory) {
    if (typeof name !== 'string') {
        factory = deps;
        deps = name;
        name = null;
    }
    if (!Array.isArray(deps)) {
        factory = deps;
        deps = [];
    }

    var deferred = pendingModule,
        context = createContext(name ? null : (deferred && deferred.context)).getContext();

    if (name === null && !deferred) {
        throw new Error('Unexpected define!');
    }

    if (deps.length === 0 && factory.length > 0) {
        var wrapped = context.wrapCommonJS(name || deferred.name, factory, [].concat(deferred.path, ''));
        deps = wrapped.deps;
        factory = wrapped.factory;
    }

    if (name === null || deferred && deferred.name === name) {
        var module = context._require(deps, factory, deferred.reject, deferred.path);
        deferred.resolve(module);
    } else {
        context.predefines[name] = [deps, factory, null];
    }
}

define.amd = {};

var requirejs = createContext(null);

module.exports = {
    define: define,
    require: requirejs,
    requirejs: requirejs
};